<template>
  <slot v-bind="{ visible, tags, openModal }"  />
  <VueModal
    v-model="modalActive"
    @close="handleModalClose"
  >
    <ProductModalWrapper v-bind="{ bundleProductId }" />
  </VueModal>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useProductsStore } from '@/stores'
import VueModal from '@/components/theme/render/vue-modal.vue'

import ProductModalWrapper from '@/components/products/product-modal-wrapper.vue'
import { useFueled } from '@/services/fueled'
const store = useProductsStore()

export interface Props {
  tags: string[]
  bundleProductId: number
  productHandle: string
  productId: number
}

const props = defineProps<Props>()

const { productViewed } = useFueled()

const modalActive = ref(false)

const openModal = () => {
  modalActive.value = true
  const url = new URL(window.location.href)
  url.hash = props.productHandle
  history.pushState(null, '', url.toString())
  productViewed(props.productId)
}

const handleModalClose = () => {
  modalActive.value = false
  const url = new URL(window.location.href)
  url.hash = ''
  history.pushState(null, '', url.toString())
}

const visible = computed(() => {
  if (store.filter === 'all') {
    return true
  }
  return props.tags.includes(store.filter)
})

onMounted(() => {
  const hash = window.location.hash
  if (hash && hash.slice(1) === props.productHandle) {
    modalActive.value = true
  }
})
</script>
